import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Select from '../../components/Select';
import { getReports } from '../../utils/api';
import { formatDate, getStatusBadgeVariant } from '../../utils/helpers';

export default function ReportsList() {
    const navigate = useNavigate();
    const [status, setStatus] = useState('pending');
    const [targetType, setTargetType] = useState('all');

    const { data, isLoading } = useQuery({
        queryKey: ['reports', status, targetType],
        queryFn: () => getReports({ status, targetType: targetType === 'all' ? undefined : targetType }),
    });

    const columns = [
        {
            header: 'Type',
            accessor: 'targetType',
            render: (report) => (
                <Badge variant="primary">{report.targetType || 'N/A'}</Badge>
            ),
        },
        {
            header: 'Reason',
            accessor: 'reason',
            render: (report) => (
                <span className="text-sm">{report.reason || 'No reason'}</span>
            ),
        },
        {
            header: 'Reporter',
            accessor: 'reporterId',
            render: (report) => (
                <span className="text-sm">User #{report.reporterId?.substring(0, 8)}</span>
            ),
        },
        {
            header: 'Status',
            accessor: 'status',
            render: (report) => (
                <Badge variant={getStatusBadgeVariant(report.status)}>
                    {report.status || 'pending'}
                </Badge>
            ),
        },
        {
            header: 'Submitted',
            accessor: 'createdAt',
            render: (report) => <span className="text-sm">{formatDate(report.createdAt)}</span>,
        },
    ];

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold mb-2">Content Reports</h1>
                <p className="text-muted-light dark:text-muted-dark">
                    Review and moderate reported content
                </p>
            </div>

            <Card>
                <div className="flex gap-4 mb-6">
                    <Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        className="w-48"
                    >
                        <option value="pending">Pending</option>
                        <option value="resolved">Resolved</option>
                        <option value="dismissed">Dismissed</option>
                    </Select>
                    <Select
                        value={targetType}
                        onChange={(e) => setTargetType(e.target.value)}
                        className="w-48"
                    >
                        <option value="all">All Types</option>
                        <option value="post">Posts</option>
                        <option value="comment">Comments</option>
                        <option value="user">Users</option>
                    </Select>
                </div>

                <Table
                    columns={columns}
                    data={data?.data?.reports || []}
                    loading={isLoading}
                    onRowClick={(report) => navigate(`/reports/${report._id}`)}
                    emptyState={{
                        title: 'No reports',
                        description: `No ${status} reports found`,
                    }}
                />
            </Card>
        </div>
    );
}

